import Isotope from 'isotope-layout';
const filtersContainer = document.querySelector('.js-references-filters');

if (filtersContainer) {
  const referencesContainer = document.querySelector('.references__list');
  const iso = new Isotope(referencesContainer, {
    itemSelector: '.references__item',
    layoutMode: 'fitRows'
  });

  const filters = Array.from(filtersContainer.getElementsByTagName('button'));
  filters.forEach((filter) => {
    filter.addEventListener('click', () => {
      filters.forEach((item) => {
        item.classList.add('button--outlined');
      });

      filter.classList.remove('button--outlined');
      const filterValue = filter.dataset.cat;
      iso.arrange({filter: filterValue});
    })
  })
}

// var $grid = $(".references__grid").isotope({
//   // options
//   itemSelector: ".references__item",
//   // layoutMode: "fitRows",
// });

// $(".filter-button-group").on("click", "button", function () {
//   $(".filter-button").removeClass("is-checked");
//   $(this).addClass("is-checked");
//   var filterValue = $(this).attr("data-filter");
//   $grid.isotope({ filter: filterValue });
// });

